app.controller('SiteMapController', ['$scope', 'WdHttpService', 'sessionService', 'config',
    function($scope, WdHttpService, sessionService, config) {

        var filterArray = {};

        $scope.init = async function() {
            var pages = ['', 'login',
                'faq', 'fund-discovery', 'terms-and-conditions', 'privacy-policy'
            ];

            // pages = pages.concat(await $scope.fetchFunds()); // deleted for AMW

            $scope.xmlData = await generateSitemap(pages, await $scope.fetchFunds());
            document.getElementById('xmlData').innerText = '<?xml version="1.0" encoding="utf-8" standalone="yes" ?>' + new XMLSerializer().serializeToString($scope.xmlData);
        }

        async function generateSitemap(pageList, adviserWisefunds) {
            var doc = document.implementation.createDocument("", "", null);
            var urlset = doc.createElement("urlset");
            urlset.setAttribute("xmlns", "http://www.sitemaps.org/schemas/sitemap/0.9");
            for (let index = 0; index < pageList.length; index++) {
                for (const key in ADVISERS_SUBDOMAIN_MAP) {
                    const page = pageList[index];
                    if (ADVISERS_SUBDOMAIN_MAP.hasOwnProperty(key)) {
                        const subdomain = ADVISERS_SUBDOMAIN_MAP[key];

                        var url = doc.createElement("url");
                        var loc = doc.createElement("loc");
                        loc.innerHTML = 'https://' + subdomain + '.wealthdesk.in/' + page;
                        url.appendChild(loc);
                        urlset.appendChild(url);
                    }
                }
            }

            ;
            for (const key in ADVISERS_SUBDOMAIN_MAP) {
                if (ADVISERS_SUBDOMAIN_MAP.hasOwnProperty(key)) {
                    const subdomain = ADVISERS_SUBDOMAIN_MAP[key];

                    for (const adviser in adviserWisefunds) {
                        if (adviserWisefunds.hasOwnProperty(adviser) && key == adviser) {
                            const fundsList = adviserWisefunds[adviser];
                            fundsList.forEach(fundUrl => {
                                var url = doc.createElement("url");
                                var loc = doc.createElement("loc");
                                loc.innerHTML = 'https://' + subdomain + '.wealthdesk.in/' + fundUrl;
                                url.appendChild(loc);
                                urlset.appendChild(url);
                            });
                        }
                    }

                }
            }

            doc.appendChild(urlset);
            doc.standalone = true;
            doc.version = '1.0';
            return doc;
        }

        $scope.fetchFunds = async function() {
            // Change this Json Object as per the deployment repo
            var data = {
                size: 5000,
                f: "web_admin:" + $scope.webadminName
            };
            var adviserWiseFundList = {};
            // for (const key in ADVISERS_SUBDOMAIN_MAP) {
            //     adviserWiseFundList[key] = [];
            // }

            $scope.showPageLoader();
            await WdHttpService._get_funds(data)
                .then(function(response) {
                    var fundsLength = response.data.Items.length;
                    if (fundsLength > 0) {
                        $scope.fundData = response.data.Items;

                        angular.forEach($scope.fundData, function(value, key) {

                            if (adviserWiseFundList[value.adviserUsername])
                                adviserWiseFundList[value.adviserUsername].push('fund-details/' + value.fundName);
                            else {
                                adviserWiseFundList[value.adviserUsername] = [];
                                adviserWiseFundList[value.adviserUsername].push('fund-details/' + value.fundName);
                            }

                        });
                    }
                    $scope.hidePageLoader();
                }).catch(error => {
                    console.log(error);
                    $scope.showErrorPopup(error);
                    $scope.hidePageLoader();
                });
            return adviserWiseFundList;
        }

        $scope.filter = function(key, value) {
            filterArray = {};
            if (filterArray[key] == undefined)
                filterArray[key] = value;
            else
                filterArray[key] = filterArray[key] + ',' + value;
            return constructRequest();
        }

        function constructRequest() {
            var requestString = '';
            var allKeys = Object.keys(filterArray);
            allKeys.forEach(key => {
                var filterValues = filterArray[key].split(',');
                var condition = '';
                filterValues.forEach(value => {
                    condition += buildCondition(key, value, condition)
                });
                condition += '';
                if (condition !== '()') {
                    if (requestString === '')
                        requestString = condition;
                    else
                        requestString += 'AND' + condition;
                    condition = '';
                }
            });

            return requestString;
        }

        function buildCondition(key, value, condition) {
            if (condition.indexOf(key) == -1)
                return key + ':' + value;
            else
                return '+' + key + ':' + value;
        }

    }
]);